export default __webpack_public_path__ + "40d3ff395227c60a941ba1767a5692b7.svg";